import { useSyncExternalStore } from 'react'

// Mobile layout below 768px, plus phones held sideways (~850px wide but short,
// with a touch screen). Decided by the viewport, not the User-Agent, and
// re-evaluated live on resize or rotation.
export const MOBILE_QUERY = '(max-width: 767px), (pointer: coarse) and (max-height: 500px)'

const mql = typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY) : null

function subscribe(onChange: () => void): () => void {
  mql?.addEventListener('change', onChange)
  return () => mql?.removeEventListener('change', onChange)
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, () => mql?.matches ?? false)
}
